import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { API_JAVA_AUTH_IMPRESSAO, API_JAVA_SERVICO_IMPRESSAO } from "../app.api";
import { RequestImpressaoModel } from "../model/request-impressao.model";
import { HttpUtilService } from "./http-util.service";
import { MessageService } from "./message.service";

@Injectable({
    providedIn: 'root'
})
export class ImpressaoService {

    constructor(
        private httpUtilService: HttpUtilService,
    ) { }

    private consultarServicoAuthImpressao(): Observable<any> {
        return this.httpUtilService.get(API_JAVA_AUTH_IMPRESSAO);
    }

    private getTokenImpressao(): Promise<string> {
        return new Promise((resolve, reject) => {

            const tknImpObserver = {
                next: result => resolve(result['data']['token']),
                error: err => reject(err),
                complete: () => { }
            };

            const token$ = this.consultarServicoAuthImpressao();
            token$.subscribe(tknImpObserver);
        });
    }

    private consultarServicoImpressaoContrato(params: RequestImpressaoModel, token): Observable<any> {
        return this.httpUtilService.postImpressao(API_JAVA_SERVICO_IMPRESSAO, params, token);
    }

    public async downaloadPdfContrato(params: RequestImpressaoModel): Promise<string> {

        const token: string  = await this.getTokenImpressao();

        return new Promise<string>((resolve, reject) => {

            const impressaoObserver = {
                next: result => {
                    if (!result.errors.length) {
                        const contrato: string = result['data'];
                        resolve(contrato);
                    } else {
                        reject(result.errors);
                    }
                },
                error: err => reject(err),
                complete: () => { }
            };

            const contrato$ = this.consultarServicoImpressaoContrato(params, token);
            contrato$.subscribe(impressaoObserver);
        });
    }

}